if (!customElements.get("sub-widget-310")) {
    customElements.define(
      "sub-widget-310",
      class SubWidget310 extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init(){

            this.handlePlanClick = this.handlePlanClick.bind(this);

            this.sellingPlanInput = this.querySelector("input[type='hidden']");
            this.allPlans = this.querySelectorAll(".sub-widget__plans");

            this.addEventListeners();
            this.setInitialPlan();
        }

        setInitialPlan(){
          const initialPlanSelected = this.querySelector('.sub-widget__plans--selected');
          if(initialPlanSelected){
            this.handlePlanClick(initialPlanSelected);
          }
        }

        reinit(){
          this.sellingPlanInput = this.querySelector("input[type='hidden']");
          this.allPlans = this.querySelectorAll(".sub-widget__plans");
          this.allPlans.forEach(plan => {
            plan.addEventListener("click", () => this.handlePlanClick(plan));
          });

          this.setInitialPlan();
        }

        addEventListeners() {
            this.allPlans.forEach(plan => {
                plan.addEventListener("click", () => this.handlePlanClick(plan));
            });

            subscribe(PUB_SUB_EVENTS.variantChange, (e) => {

              console.log(e);

              const parsedHTML = e.data.html.querySelector(".sub-widget__container");
              const currentContainer = this.querySelector('.sub-widget__container')
              currentContainer.innerHTML = parsedHTML.innerHTML;

              this.reinit();
            });
        }

        handlePlanClick(plan) {
          // set new active plan
          this.allPlans.forEach(item => {
                item.classList.remove("sub-widget__plans--selected");
            });
            plan.classList.add("sub-widget__plans--selected");

            // set new selected plan value
            const selectedPlanValue = plan.querySelector("select")?.value;
            if(selectedPlanValue) {
              this.sellingPlanInput.value = selectedPlanValue;
              const selectedOption = [...plan.querySelector("select").options].find(option => option.value === selectedPlanValue);
              if(selectedOption){
                const compareAtPrice = selectedOption.dataset.compareAtPrice;
                const price = selectedOption.dataset.price;
                this.updatePrice(plan,compareAtPrice, price);
              }
              
            } else {
              this.sellingPlanInput.value = null;
            }

            this.updateURLParams(selectedPlanValue);
        }

        updatePrice(plan, compareAtPrice, price){

          const priceElement = plan.querySelector('.subwidget__plan-header__price-regular');
          const compareAtPriceElement = plan.querySelector('.subwidget__plan-header__price-sale');

          if(compareAtPrice){
            compareAtPriceElement.innerHTML = compareAtPrice;
            priceElement.classList.add('subwidget__plan-header__price-regular--sale');
          } else {
            priceElement.classList.remove('subwidget__plan-header__price-regular--sale');
          }

          if(price){
            priceElement.innerHTML = price;
          }
          

        }

        updateURLParams(planId){
          const urlParams = new URLSearchParams(window.location.search);
          if(planId){
            urlParams.set("selling_plan", planId);
          } else {
            urlParams.delete("selling_plan");
          }
          window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
        }
    
        disconnectedCallback() {
        }
      },
    );
  }
  